import {ErrorStateScheduleEnum} from '../../error-state-schedule.enum';

export enum CompanyRegistrationFormErrorStatesEnum {
    CompanyRegistrationFailed = ErrorStateScheduleEnum.CompanyRegistrationFormStatesStartIndex,
    GetCompanyFailed,
    TaxDetailsUpdateFailed,
    TaxDetailsRegistrationFailed,
    VatDetailsUpdateFailed,
    UpdateResidentialAddressFailed,
    ResidentialAddressRegistrationFailed,
    UpdateMailingAddressFailed,
    MailingAddressRegistrationFailed,
    UploadDocumentFileForRegistrationFailed,
    DocumentRegistrationFailed,
    UploadDocumentFileForUpdateFailed,
    UpdateDocumentFailed,
    UploadProofOfAddressDocumentFileForRegistrationFailed,
    ProofOfAddressDocumentRegistrationFailed,
    UploadProofOfAddressDocumentFileForUpdateFailed,
    UpdateProofOfAddressDocumentFailed,
    UpdateStatusToPendingFailed,
    UpdateStatusToPendingAcceptanceFailed,
    UpdateStatusToForVerificationFailed
}
